<div class="row row-page-title page-row">

  <div class="title-page-col">

    <h1 class="page-title">
      Listagem de Empresas
    </h1>

  </div>

  <div class="title-button-col">

    <button
      class="btn-principal"
      style="width: 157px"
      routerLink="/company/create"
    >
      Nova Empresa
    </button>

  </div>

</div>

<div class="row row-info-input page-row">

  <div class="col-info-input col-3">

    <p class="page-subtitle">
      Buscar
    </p>

    <input
      matInput
      #companyNameRef
      [(ngModel)]="companyName"
      (change)="filterTable($event.target.value, 'name')"
      (focus)="filterTable($event.target.value, 'name')"
      type="text"
      placeholder="Buscar"
      class="search-input"
    >

  </div>

  <div class="col-info-input col-3">

      <p class="page-subtitle">
        Buscar Situação
      </p>

      <select
        matInput
        #companySituationRef
        (change)="filterSituationTable($event.target.value)"
        (focus)="filterSituationTable($event.target.value)"
        class="select-input"
      >
        <option [value]="''">Todos</option>
        <option [value]="true">Ativo</option>
        <option [value]="false">Inativo</option>
      </select>

    </div>

    <div class="col-info-input col-3">

      <p class="page-subtitle">
        Buscar Versão
      </p>

      <input
        matInput
        #versionRef
        type="text"
        class="search-input"
        [(ngModel)]="version"
        placeholder="Buscar Versão"
        (change)="filterTable($event.target.value, 'motelVersion')"
        (focus)="filterTable($event.target.value, 'motelVersion')"
      >

    </div>

    <div class="col-info-input col-3">

      <p class="page-subtitle">
        Buscar Data Licença
      </p>

      <input
        matInput
        #licenceRef
        type="text"
        class="search-input"
        [(ngModel)]="licenceDate"
        placeholder="Buscar Data Licença"
        (change)="filterTable($event.target.value, 'licenceDate')"
        (focus)="filterTable($event.target.value, 'licenceDate')"
      >

    </div>

</div>

<div class="row page-row row-content">

  <table mat-table matSort [dataSource]="dataSource" class="table-striped">

    <ng-container matColumnDef="Name">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Empresa
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(element.name) ? element.name : '-'}}
      </td>

    </ng-container>

    <ng-container matColumnDef="Admin">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Admin.
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(element.admin) ? element.admin : '-'}}
      </td>

    </ng-container>

    <ng-container matColumnDef="E-mail">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        E-mail
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(element.email) ? element.email : '-'}}
      </td>

    </ng-container>

    <ng-container matColumnDef="ApiToken">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
      Token Identificação Motel
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(element.apiToken) ? element.apiToken : '-'}}
      </td>

    </ng-container>

    <ng-container matColumnDef="licenceDate">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Data Limite Acesso
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(!element.licenceDate) ? '-' : element.licenceDate.substr(0, 10)}}
      </td>

    </ng-container>

    <ng-container matColumnDef="motelVersion">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Versão
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{ element.motelVersion || '-' }}
      </td>

    </ng-container>

    <ng-container matColumnDef="LastCheck">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Últ. Checagem
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        {{(!element.lastCheck) ? '-' : dateFormat(element.lastCheck, false)}}
      </td>

    </ng-container>

    <ng-container matColumnDef="statusDatabase">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        <span class="status-database"></span>
      </th>

      <td
        class="table-cell"
        mat-cell
        *matCellDef="let element"
      >
        <span *ngIf="element.statusDatabase === 2" class="status-database-ok"></span>
        <span *ngIf="element.statusDatabase !== 2" class="status-database-in-progress"></span>
      </td>

    </ng-container>

    <ng-container matColumnDef="Situation">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Situação
      </th>

      <td
        class="table-cell"
        [ngClass]="{'inactive-company': element.isActive !== true}"
        mat-cell
        *matCellDef="let element"
      >
        {{ (element.isActive === true) ? 'Ativo' : 'Inativo' }}
      </td>

    </ng-container>

    <ng-container matColumnDef="Options">

      <th
        class="table-header-labels table-cell"
        mat-header-cell
        *matHeaderCellDef
      >
        Opções
      </th>

      <td
        mat-cell
        *matCellDef="let element"
        class="table-cell"
      >
       <i (click)="onOptionsClicked(element.id)" class="options-icon"></i>
       <i (click)="onInfoOptionClicked(element.id)" class="fa fa-info info-icon"></i>
       <i (click)="onDeleteOptionClicked(element.id)" class="options-icon delete" style="margin-left: 10px;;"></i>
      </td>
    </ng-container>

    <tr class="table-header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator
    [pageSize]="10"
  ></mat-paginator>

</div>

<ngx-ui-loader
  [fgsColor]="loaderConfig.fgsColor"
  [fgsPosition]="loaderConfig.fgsPosition"
  [fgsSize]="loaderConfig.fgsSize"
  [fgsType]="loaderConfig.fgsType"
  [bgsColor]="loaderConfig.bgsColor"
  [bgsOpacity]="loaderConfig.bgsOpacity"
  [bgsPosition]="loaderConfig.bgsPosition"
  [bgsSize]="loaderConfig.bgsSize"
  [bgsType]="loaderConfig.bgsType"
  [gap]="loaderConfig.gap"
  [logoPosition]="loaderConfig.logoPosition"
  [logoSize]="loaderConfig.logoSize"
  [logoUrl]="loaderConfig.logoUrl"
  [overlayColor]="loaderConfig.overlayColor"
  [pbColor]="loaderConfig.pbColor"
  [pbDirection]="loaderConfig.pbDirection"
  [pbThickness]="loaderConfig.pbThickness"
  [hasProgressBar]="loaderConfig.hasProgressBar"
  [text]="loaderConfig.text"
  [textColor]="loaderConfig.textColor"
  [textPosition]="loaderConfig.textPosition"
></ngx-ui-loader>
